<template>
  <!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista atributos, permite consultar, crear, editar y eliminar atributos disponibles 
    * Autor: 
    * F.Creación: 
  -->
  <layout :title="$t('moduleTitle')">
    <!-- Contenido -->
    <template v-slot:content>
      <!-- modal con formulario para la creacion de nuevo atributo -->
      <v-dialog persistent v-model="newDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("tblbutton")}}</v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="newForm" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :rules="nameRules"
                      :counter="30"
                      v-model="currentatributtes.titulo"
                      :label="$t('lbltittle')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :rules="descriptionRules"
                      :counter="200"
                      v-model="currentatributtes.body"
                      :label="$t('lblName')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select v-model="selected" :label="$t('lblType')" :items="checkbox_options"></v-select>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeNewDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doNewDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- modal con formulario para la edicion de un atributo  -->
      <v-dialog persistent v-model="uploadDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("tblbutton")}}</v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="newForm" lazy-validation>
                <v-row>
                 
                  <v-col cols="12">
                    <v-text-field
                      :rules="nameRules"
                      :counter="30"
                      v-model="currentatributtes.title"
                      :label="$t('lbltittle')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :rules="descriptionRules"
                      :counter="200"
                      v-model="currentatributtes.body"
                      :label="$t('lblName')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="currentatributtes.type"
                      :label="$t('lblType')"
                      :items="checkbox_options"
                    ></v-select>
                    <!-- <strong>{{ selected }}</strong> -->
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeUploadDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doUploadDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Formulario para eliminar un atributo -->
      <v-dialog persistent v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgDeleteMapTitle")}}</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-alert outlined type="warning" prominent border="left">
                    {{$t('lbldelete1')}}
                    <br />
                    <strong>{{currentatributtes.name}}</strong>
                    <!-- <strong>{{currentatributtes.id}}</strong> -->
                    <br />
                    {{$t('lbldelete2')}}
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <p class="caption error--text" v-html="errorMessage"></p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeDeleteDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doDeleteDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- caja de texto para buscar informacion en tabla de contenido -->
      <v-text-field
        solo
        class="mt-4"
        :label="$t('headerSearch')"
        prepend-inner-icon="mdi-account"
        v-model="search"
      ></v-text-field>
      <!-- Tabla de contenido -->
      <v-data-table
        :headers="headers"
        :items="avisos"
        :loading="isLoading"
        :search="search"
        loading-text="Cargando elementos en tabla"
        color="primary"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{$t('tblTitle')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-select v-model="filter" :items="checkbox_options" attach></v-select>
            <v-spacer></v-spacer>
            <v-btn class="ma-2" color="primary" @click.stop="newDialog = true">{{$t('tblbutton')}}</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.status="{ item }">
          <v-col v-if="item.status === 1">
            <v-btn icon :color="getStatusColor(item)" @click="showUploadDialog(item)">
              <v-icon>mdi-send</v-icon>
            </v-btn>
          </v-col>
          <v-col v-else>
            <v-btn icon color="grey" @click="showUploadDialog(item)">
              <v-icon>mdi-send</v-icon>
            </v-btn>
          </v-col>
        </template>
        <!-- Panel Tiopo de aviso -->
        <template v-slot:item.type="{ item }">
          <v-col>
            {{ getTypeName(item.type) }}
          </v-col>
        </template>
        <!-- Panel de acciones -->
        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="showUploadDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblEdit')}}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar">
        {{ mensaje }}
        <v-btn color="primary" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </template>
  </layout>
</template>

<script>
// Incluimos el LAYOUT estandar para los usuario que ya tienen
// una sesión activa
import Layout from "@/components/Layouts/company";
// Incluimos los mensajes de esta pantalla
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  // Se definen los componentes requeridos por esta pantalla
  components: {
    layout: Layout,
  },
  created() {
    this.$i18n.locale = this.locale;
    // Obtenemos la lista de atributos
    this.loadData();
    //inicializamos encabezados de la tabla
    this.updateHeadersLocale();
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function () {
    return {
      // Se utilizan como banderas (FLAG) para
      // los cuadros de dialogo
      newDialog: false,
      deleteDialog: false,
      uploadDialog: false,
      viewDialog: false,
      selected: null,
      filter: 0,
      //variables  para control de validaciones
      snackbar: false,
      mensaje: "",
      search: "",
      loading: true,
      dialog: false,
      //arreglo para almacenar los atributos
      atributtes: [],
      //arreglo para almacenar cambios de atributos
      currentatributtes: {},
      errorMessage: "",
      //validaciones de formularios
      nameRules: [(v) => v.length < 31 || this.$t("ruleTitle")],
      descriptionRules: [(v) => v.length < 201 || this.$t("ruleName")],
      minValueRules: [
        (v) =>
          v.length < 3 || "el valor minimo no puede exceder los 2 caracteres",
      ],
      maxValueRules: [
        (v) =>
          v.length < 4 || "el valor maximo no puede exceder los 3 caracteres",
      ],
      //encabezados de la tabla
      headers: [
        { id: "headerTitle", text: "", value: "title" },
        { id: "headerName", text: "", value: "body" },
        { id: "headerType", text: "", value: "type" },
        {
          id: "headerStatus",
          text: "",
          value: "status",
          sortable: true,
        },
        
      ],
      avisos: [],
      checkbox_options: [
        { value: 0, text: "General" },
        { value: 1, text: "Internos" },
        { value: 2, text: "Externos" },
      ],
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    },
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
      this.updateHeadersLocale();
    },
    filter(){
      this.loadData();
    }
  },
  methods: {
    getStatusColor(item) {
      let { status } = item;
      let color = status === 1 ? "primary" : "grey";
      return color;
    },
    setCurrentAttrib(item) {
      //Realizamos una copia del objeto atributo
      //utilizan el método clone de la utileria LODASH
      this.currentatributtes = _.clone(item);
    },
    // Actualiza el idioma de los encabezados de la tabla
    updateHeadersLocale() {
      this.headers = this.headers.map((header) => {
        header.text = this.$t(header.id);
        return header;
      });
    },
    //consulta avisos desde lambda, asignacion de datos a arreglo avisos
    loadData() {
      this.$GET("/api/notifications/getNotice", [])
        .then((data) => {
          // if (this.filter == 0) {
          //   this.avisos = data;
          // } else {
          //   this.avisos = data.filter((item) => {
          //     return item.type == this.filter;
          //   });
          // }
          this.avisos = data.filter((item) => {
            return item.type == this.filter;
          });
          /* this.avisos = data;
          console.log("avisos:", this.avisos); */
        })
        .catch((e) => {
          console.log("error avisos", e);
        });
    },
    //cerrar modal con formulario para crear nuevo aviso
    closeNewDialog() {
      this.newDialog = false;
      this.$refs.newForm.reset();
      this.currentatributtes = {};
      this.errorMessage = "";
    },
    //proceso de creacion de nuevo aviso
    doNewDialog() {
      if (this.selected == null) {
        this.snackbar = true;
        this.mensaje = this.$t("lblValidation1");
      } 
      else if (
        this.currentatributtes.titulo == null ||
        this.currentatributtes.titulo == ""
      ) {
        this.snackbar = true;
        this.mensaje = this.$t("lblValidation2");
      } else if (
        this.currentatributtes.body == null ||
        this.currentatributtes.body == ""
      ) {
        this.snackbar = true;
        this.mensaje = this.$t("lblValidation3");
      } else {
        let payload = {
          data: {
            Title: this.currentatributtes.titulo,
            Body: this.currentatributtes.body,
            Type: this.selected,
            Role: 2,
          },
        };
        this.$POST("/api/notifications/sendPush", payload)
          .then((response) => {
            console.log("se registro el aviso", response);
            this.newDialog = false;
            this.errorMessage = "";
            this.currentatributtes = {};
            this.selected = null;
            // this.loadData();
            payload.data.Status = 1;
            // Guarda en base
            this.createNotice(payload.data);
          })
          .catch((e) => {
            // En caso de error presentar un mensaje
            // al usuario
            payload.Status = 0;
            // Guarda en base
            this.createNotice(payload);
            console.log("error con endpint", e);
            // this.errorMessage = "Ocurrió un error al crear el aviso";
          })
          .finally(() => {});
      }
    },
    //mostrar modal para la edicion de un aviso
    showUploadDialog(item) {
      //this.currentatributtes = item;
      this.setCurrentAttrib(item);
      confirm(this.$t('lblResendNotification')) && this.doUploadDialog();
    },
    //proceso de edicion de un aviso existente
    doUploadDialog() {
      let payload = {
        data: {
          Title: this.currentatributtes.titulo,
          Body: this.currentatributtes.body,
          Type: this.currentatributtes.type,
          Role: 2,
        },
      };
      this.$POST("/api/notifications/sendPush", payload)
        .then((response) => {
          console.log("se registro el aviso", response);
          this.newDialog = false;
          this.errorMessage = "";
          this.currentatributtes = {};
          this.selected = null;
          // this.loadData();
          this.currentatributtes.Status = 1;
          // Guarda en base
          this.updateNotice();
        })
        .catch((e) => {
          // En caso de error presentar un mensaje
          // al usuario
          this.currentatributtes.Status = 1;
          // Guarda en base
          this.updateNotice();
          console.log("error con endpint", e);
          // this.errorMessage = "Ocurrió un error al crear el aviso";
        })
        .finally(() => {});
    },
    /**
     * Editar un aviso
     */
    updateNotice() {
      let payload = {
        data: {
          Id: this.currentatributtes.id,
          Title: this.currentatributtes.title,
          Body: this.currentatributtes.body,
          Type: this.currentatributtes.type,
          Role: 2,
          Status: this.currentatributtes.status,
          LastUpdate: this.currentatributtes.lastUpdate,
        },
      };
      //console.log("/api/notifications/updateNotice", payload);
      this.$POST("/api/notifications/updateNotice", payload)
        .then(() => {
          //** console.log(response);
          this.loadData();
          this.uploadDialog = false;
          this.currentatributtes = {};
          if(payload.Status == 0){
            this.snackbar = true;
            this.mensaje = this.$t("El aviso no se pudo enviar, puede reenviarlo mas tarde");
          }
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
          this.errorMessage = "Ocurrió un error al editar el aviso";
          this.snackbar = true;
          this.mensaje = this.$t("lblCreateError");
        })
        .finally(() => {});
    },
    /**
     * Crea un nuevo aviso en la base de datos
     * @param notification
     */
    createNotice(notification) {
      let payload = {
        data: {
          Title: notification.Title,
          Body: notification.Body,
          Type: notification.Type,
          Role: 2,
          Status: notification.Status,
        },
      };
      //console.log("/api/notifications/updateNotice", payload);
      this.$POST("/api/notifications/setNotice", payload)
        .then(() => {
          // Creacion exitosa
          this.loadData();
          if(payload.Status == 0){
            this.snackbar = true;
            this.mensaje = this.$t("El aviso no se pudo enviar, puede reenviarlo mas tarde");
          }
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          this.snackbar = true;
          this.mensaje = this.$t("lblCreateError");
        })
        .finally(() => {});
    },
    //cerrar modal para la edicion de un aviso
    closeUploadDialog() {
      this.uploadDialog = false;
      this.currentatributtes = { resource: {} };

      this.errorMessage = "";
    },
    /**
     * Obtiene el nombre del tipo de notificacion
     * @param type Id del tipo
     */
    getTypeName(type){
      let checkbox_option = this.checkbox_options.find( customer => customer.value == type);
      return checkbox_option ? checkbox_option.text : '';
    },
  },
};
</script>